<article class="checkride-card" [class.is-expanded]="expanded">
    <button type="button" class="checkride-summary" (click)="expandedChange.emit(!expanded)" [attr.aria-expanded]="expanded">
        <span class="checkride-time">
            <strong>{{card.time}}</strong>
            <small *ngIf="card.duration">{{card.duration}}</small>
        </span>
        <span class="checkride-person">
            <strong *ngIf="card.applicantName">{{card.applicantName}}</strong>
            <small *ngIf="card.summary">{{card.summary}}</small>
            <small *ngIf="examinerLabel">{{examinerLabel}}: {{card.examinerName || 'None'}}</small>
            <small *ngIf="showFlightSchool && card.flightSchool">{{card.flightSchool}}</small>
        </span>
        <span class="card-badges">
            <span class="status-pill" *ngIf="card.status">{{card.status}}</span>
            <span class="payment-pill" *ngIf="card.paymentNotMade">{{card.paymentBadge}}</span>
        </span>
        <i class="fa" [ngClass]="expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </button>

    <div class="checkride-details" *ngIf="expanded">
        <dl>
            <div><dt>Category/Grade</dt><dd>{{card.gradeClass}}</dd></div>
            <div><dt>Type of practical test</dt><dd>{{card.testType}}</dd></div>
            <div><dt>Airport</dt><dd>{{card.airport}}</dd></div>
            <div *ngIf="examinerLabel"><dt>{{examinerLabel}}</dt><dd>{{card.examinerName || 'None'}}</dd></div>
            <div *ngIf="showFlightSchool"><dt>Flight school</dt><dd>{{card.flightSchool || 'None'}}</dd></div>
            <div><dt>Instructor</dt><dd>{{card.flightInstructorName || 'None'}}</dd></div>
            <div><dt>IACRA FTN</dt><dd>{{card.iacraFtn}}</dd></div>
            <div><dt>Scheduled cost</dt><dd>{{card.scheduledCost != null ? (card.scheduledCost | currency) : 'None'}}</dd></div>
            <div><dt>Booking ID</dt><dd>{{card.bookingId}}</dd></div>
        </dl>
        <div class="checkride-actions">
            <button type="button" class="card-action primary" (click)="openCheckride()"><i class="fa fa-external-link-alt"></i> Open checkride</button>
            <button type="button" class="card-action" *ngIf="showPlanOfActionActions && card.hasPlanOfAction" (click)="openPlanOfAction()"><i class="fa fa-map"></i> Open POA</button>
            <button type="button" class="card-action" *ngIf="showPlanOfActionActions && card.canGeneratePlanOfAction" (click)="openPlanOfAction()"><i class="fa fa-map"></i> Generate POA</button>
        </div>
    </div>
</article>
